module.exports = __webpack_public_path__ + "static/media/pic4.41510cc3.jpg";